import {
  FormControlLabel,
  Radio,
  RadioGroup,
  FormControl,
  Grid,
} from "@mui/material";
import { red, orange, cyan } from "@mui/material/colors";
import SquareSharpIcon from "@mui/icons-material/SquareSharp";
import CropSquareSharpIcon from "@mui/icons-material/CropSquareSharp";
import FormLabel from "@mui/material/FormLabel";

const CustomRadioButton = (props) => {
  return (
    <Grid container>
      <Grid
        item
        sm={props.textCol}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "left",
          p: 0
        }}
      >
        <FormLabel className={props.classLabel} htmlFor={props.id}>
          {props.labelText}
        </FormLabel>
      </Grid>
      <Grid item sm={props.inputCol} display="flex" sx={{ p: 1 }}>
        <FormControl>
          <RadioGroup row>
            <FormControlLabel
              control={
                <Radio
                  icon={<CropSquareSharpIcon />}
                  checkedIcon={<SquareSharpIcon />}
                  onClick={props.onClickRedButton}
                  checked={props.checkRadioRed}
                  sx={{
                    color: red[800],
                    "&.Mui-checked": {
                      color: red[600],
                    },
                  }}
                />
              }
            />
            <FormControlLabel
              value="Orange"
              control={
                <Radio
                  icon={<CropSquareSharpIcon />}
                  checkedIcon={<SquareSharpIcon />}
                  onClick={props.onClickOrangeButton}
                  checked={props.checkRadioOrange}
                  sx={{
                    color: orange[800],
                    "&.Mui-checked": {
                      color: orange[600],
                    },
                  }}
                />
              }
            />
            <FormControlLabel
              value="White"
              control={
                <Radio
                  icon={<CropSquareSharpIcon />}
                  checkedIcon={<SquareSharpIcon />}
                  onClick={props.onClickWhiteButton}
                  checked={props.checkRadioWhite}
                  sx={{
                    color: cyan[300],
                    "&.Mui-checked": {
                      color: cyan[200],
                    },
                  }}
                />
              }
            />
          </RadioGroup>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default CustomRadioButton;
